@if (config) {
    @if (spacers?.top) {
        <sirius-spacer></sirius-spacer>
    }
    <ng-template siriusDynamicElement [config]="config"></ng-template>
    @if (spacers?.bottom) {
        <sirius-spacer></sirius-spacer>
    }
} @else {
    <ng-content></ng-content>
}
